import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { BASENAME } from "@/lib/basename";
import { PwaHeadSync } from "@/components/PwaHeadSync";
import { AuthProvider, useAuth } from "@/lib/auth";
import { ThemeProvider } from "@/lib/theme";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import DashboardLayout from "@/pages/DashboardLayout";
import Dashboard from "@/pages/Dashboard";
import Students from "@/pages/Students";
import Plans from "@/pages/Plans";
import Workouts from "@/pages/Workouts";
import Turnstile from "@/pages/Turnstile";
import Attendance from "@/pages/Attendance";
import Finance from "@/pages/Finance";
import DailyCash from "@/pages/DailyCash";
import MonthlyBalance from "@/pages/MonthlyBalance";
import Users from "@/pages/Users";
import Units from "@/pages/Units";
import UnitsDashboard from "@/pages/UnitsDashboard";
import Communications from "@/pages/Communications";
import CRM from "@/pages/CRM";
import QuickSale from "@/pages/QuickSale";
import Shop from "@/pages/Shop";
import Devices from "@/pages/Devices";
import StudentPortal from "@/pages/StudentPortal";
import PortalLogin from "@/pages/PortalLogin";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import PayLink from "@/pages/PayLink";
import FaceEnroll from "@/pages/FaceEnroll";
import Settings from "@/pages/Settings";
import StudentsMap from "@/pages/StudentsMap";
import ExerciseLibrary from "@/pages/ExerciseLibrary";
import ExerciseVideos from "@/pages/ExerciseVideos";
import Kiosk from "@/pages/Kiosk";
import StaffRatings from "@/pages/StaffRatings";
import SelfSignup from "@/pages/SelfSignup";
import Notices from "@/pages/Notices";
import GymFeedback from "@/pages/GymFeedback";
import Landing from "@/pages/Landing";
import LandingConfig from "@/pages/LandingConfig";
import Reports from "@/pages/Reports";
import Auditoria from "@/pages/Auditoria";
import StaffNotices from "@/pages/StaffNotices";
import StaffNoticesBoard from "@/pages/StaffNoticesBoard";
import SecurityPanel from "@/pages/SecurityPanel";
import MigracaoNextFit from "@/pages/MigracaoNextFit";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const HomeRoute = () => {
  const { user } = useAuth();
  if (user?.role !== "admin") return <Navigate to="/venda-rapida" replace />;
  return <Dashboard />;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/portal/login" element={<PortalLogin />} />
      <Route path="/portal/:studentId" element={<StudentPortal />} />
      <Route path="/face-enroll/:token" element={<FaceEnroll />} />
      <Route path="/totem" element={<Kiosk />} />
      <Route path="/totem/:unitId" element={<Kiosk />} />
      <Route path="/autocadastro" element={<SelfSignup />} />
      <Route path="/autocadastro/:unitId" element={<SelfSignup />} />
      <Route path="/loja" element={<Landing />} />
      <Route path="/pagar/:token" element={<PayLink />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/" element={<Protected><DashboardLayout /></Protected>}>
        <Route index element={<HomeRoute />} />
        <Route path="alunos" element={<Students />} />
        <Route path="mapa-alunos" element={<StudentsMap />} />
        <Route path="venda-rapida" element={<QuickSale />} />
        <Route path="planos" element={<Plans />} />
        <Route path="treinos" element={<Workouts />} />
        <Route path="biblioteca-exercicios" element={<ExerciseLibrary />} />
        <Route path="videos-american-fit" element={<ExerciseVideos />} />
        <Route path="catraca" element={<Turnstile />} />
        <Route path="frequencia" element={<Attendance />} />
        <Route path="financeiro" element={<Finance />} />
        <Route path="caixa-dia" element={<DailyCash />} />
        <Route path="balanco-mensal" element={<MonthlyBalance />} />
        <Route path="pdv" element={<Shop />} />
        <Route path="comunicados" element={<Communications />} />
        <Route path="crm" element={<CRM />} />
        <Route path="consolidado" element={<UnitsDashboard />} />
        <Route path="unidades" element={<Units />} />
        <Route path="dispositivos" element={<Devices />} />
        <Route path="usuarios" element={<Users />} />
        <Route path="avaliacoes" element={<StaffRatings />} />
        <Route path="avisos" element={<Notices />} />
        <Route path="feedback-alunos" element={<GymFeedback />} />
        <Route path="site-vendas" element={<LandingConfig />} />
        <Route path="relatorios" element={<Reports />} />
        <Route path="auditoria" element={<Auditoria />} />
        <Route path="seguranca" element={<SecurityPanel />} />
        <Route path="mural" element={<StaffNoticesBoard />} />
        <Route path="avisos-usuarios" element={<StaffNotices />} />
        <Route path="configuracoes" element={<Settings />} />
        <Route path="migracao-nextfit" element={<MigracaoNextFit />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter basename={BASENAME}>
            <PwaHeadSync />
            <AppRoutes />
            <Toaster position="top-right" richColors />
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
